import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel , Autocomplete, Select, MenuItem} from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useSaleChannelStore } from "../../../hooks/useSaleChannelStore";
import { useSellerStore } from "../../../hooks/useSellerStore";
import { useBranchOfficeStore } from "../../../hooks/useBranchOfficeStore";

type Values = {
    id: number,
    rut: string,
    name: string,
    surname: string,
    gender: string,
    birthdate: string,
    age: string,
    phone: string,
    address: string,
    email: string,
    idchannel:number,
    idbranchoffices: any,
    status: string,
    username: string,
}

const genders = [
    { id: '0', name: 'Masculino'},
    { id: '1', name: 'Femenino'},
    { id: '2', name: 'Otros'},
]

export const SellerModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, sellerSelected, listsellers, clearState } = props;

    const { action, createSeller, editSeller } = useSellerStore();
    const { getSalesChannels } = useSaleChannelStore();
    const { getBranchOffice } = useBranchOfficeStore();

    const [loading, setLoading] = useState<boolean>(false);
    const [loadingdata, setLoadingdata] = useState<boolean>(false);
    const [newuser, setNewuser] = useState<boolean>(false);
    const [channels, setchannels] = useState<any>([]);
    const [channelSelected, setChannelSelected] = useState<any>('');
    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [data, setData] = useState<Values>({
        id: sellerSelected ? sellerSelected.id :'',
        rut: sellerSelected ? sellerSelected.rut :'',
        name: sellerSelected ? sellerSelected.name :'',
        surname: sellerSelected ? sellerSelected.surname :'',
        gender: sellerSelected ? sellerSelected.gender :'',
        birthdate: sellerSelected ? sellerSelected.birthdate :'',
        age: sellerSelected ? sellerSelected.age :'',
        phone: sellerSelected ? sellerSelected.phone :'',
        address: sellerSelected ? sellerSelected.address :'',
        email: sellerSelected ? sellerSelected.email :'',
        idchannel: sellerSelected ? sellerSelected.idchannel :'',
        idbranchoffices: sellerSelected ? sellerSelected.idbranchoffices :'',
        status: sellerSelected ? sellerSelected.status :'',
        //usuario vendedor
        username: sellerSelected ? sellerSelected.username :'',
    });

    useEffect(() => {
        getSalesChannelsApi();
        getBranchOfficeApi();
    },[])

    useEffect(() => {
        if(sellerSelected && channels){
            setCustomChannels(sellerSelected.idchannel, channels)
        }
    },[sellerSelected, channels])

    const setCustomChannels = (idchannel, channels) => {
        const data = channels.find(channel => channel.id == idchannel);
        return setChannelSelected(data);
    }

    const getSalesChannelsApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getSalesChannels(search);
            if(!response){
                setchannels([]);
                setLoadingdata(false);
                return false;
            }else{
                setchannels(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const getBranchOfficeApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getBranchOffice(search);
            if(!response){
                setBranchOffices([]);
                setLoadingdata(false);
                return false;
            }else{
                setBranchOffices(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.rut) errors.rut = "el campo es requerido";
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.surname) errors.surname = "el campo es requerido";
        if(!values.gender) errors.gender = "el campo es requerido";
        if(!values.birthdate) errors.birthdate = "el campo es requerido";
        if(!values.age) errors.age = "el campo es requerido";
        if(!values.phone) errors.phone = "el campo es requerido";
        if(!values.email) errors.email = "el campo es requerido";
        if(!values.address) errors.address = "el campo es requerido";
        if(!values.idchannel) errors.idchannel = "el campo es requerido";
        if(newuser && !values.username) errors.username = "el campo es requerido";
        return errors;
    }

    const handleKeyDown = (event) => {
        const keyCode = event.keyCode || event.which;
        if (keyCode === 189 || keyCode === 109) {
          event.preventDefault();
        }
    };

    const onSubmit = async(values)  => {
        setLoading(true);

        let idbranchoffices = [];
        if(!sellerSelected && (values.idbranchoffices).length > 0) idbranchoffices = (values.idbranchoffices).map(item => item.id) || [];

        if(sellerSelected){
            const response:any = await editSeller(sellerSelected.id, {...values, type_person: '0'});
            if(response){
                listsellers && listsellers();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createSeller({...values, idbranchoffices: idbranchoffices, type_person: '0'});
            if(response){
                listsellers && listsellers();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar vendedor' : (action == 'add' ? 'Nuevo vendedor' : 'Detalle del vendedor')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Rut:</FormLabel>
                                            <TextField
                                                id="rut"
                                                type="text" 
                                                name="rut"
                                                fullWidth
                                                size="small"
                                                value={values.rut}
                                                onChange={handleChange}
                                                error={errors.rut && touched.rut ? true : false}
                                                helperText={errors.rut && touched.rut ? errors.rut : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Nombre:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Apellidos:</FormLabel>
                                            <TextField
                                                id="surname"
                                                type="text" 
                                                name="surname"
                                                fullWidth
                                                size="small"
                                                value={values.surname}
                                                onChange={handleChange}
                                                error={errors.surname && touched.surname ? true : false}
                                                helperText={errors.surname && touched.surname ? errors.surname : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Género:</FormLabel>
                                            <Select
                                                id="gender"
                                                value={values.gender}
                                                size="small"
                                                onChange={(event) => { 
                                                    setFieldValue("gender", event.target.value);
                                                }}
                                                error={ errors.gender && touched.gender ? true : false }
                                                inputProps={{ readOnly: action == 'detail' }}
                                                fullWidth
                                            >
                                                {
                                                    genders.map((gender, i) => {
                                                        return <MenuItem key={i} value={gender.id}>{gender.name}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Fecha de nacimiento:</FormLabel>
                                            <TextField
                                                id="birthdate"
                                                type="date" 
                                                name="birthdate"
                                                fullWidth
                                                size="small"
                                                value={values.birthdate}
                                                onChange={handleChange}
                                                error={errors.birthdate && touched.birthdate ? true : false}
                                                helperText={errors.birthdate && touched.birthdate ? errors.birthdate : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Edad:</FormLabel>
                                            <TextField
                                                id="age"
                                                type="number" 
                                                name="age"
                                                fullWidth
                                                size="small"
                                                value={values.age}
                                                onChange={handleChange}
                                                error={errors.age && touched.age ? true : false}
                                                helperText={errors.age && touched.age ? errors.age : ''}
                                                onKeyDown={handleKeyDown}
                                                inputProps={{ readOnly: action == 'detail' }}
                                                InputProps={{
                                                    inputProps: {
                                                    min: 1
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Teléfono:</FormLabel>
                                            <TextField
                                                id="phone"
                                                type="text" 
                                                name="phone"
                                                fullWidth
                                                size="small"
                                                value={values.phone}
                                                onChange={handleChange}
                                                error={errors.phone && touched.phone ? true : false}
                                                helperText={errors.phone && touched.phone ? errors.phone : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Correo:</FormLabel>
                                            <TextField
                                                id="email"
                                                type="email" 
                                                name="email"
                                                fullWidth
                                                size="small"
                                                value={values.email}
                                                onChange={handleChange}
                                                error={errors.email && touched.email ? true : false}
                                                helperText={errors.email && touched.email ? errors.email : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Dirección:</FormLabel>
                                            <TextField
                                                id="address"
                                                type="text" 
                                                name="address"
                                                fullWidth
                                                size="small"
                                                value={values.address}
                                                onChange={handleChange}
                                                error={errors.address && touched.address ? true : false}
                                                helperText={errors.address && touched.address ? errors.address : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Canal de venta:</FormLabel>
                                            <Autocomplete
                                                id="idchannel"
                                                size="small"
                                                value={!!channelSelected ? channelSelected : null}
                                                options={channels || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small" 
                                                        error={errors.idchannel && touched.idchannel ? true : false}
                                                        helperText={errors.idchannel && touched.idchannel ? errors.idchannel : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setChannelSelected(newValue)
                                                    setFieldValue('idchannel', newValue ? newValue.id : "");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                        {
                                            !sellerSelected && (
                                                <Grid item xs={12} md={6}>
                                                    <FormLabel>Sucursales:</FormLabel>
                                                    <Autocomplete
                                                        multiple
                                                        id="combo-box-demo"
                                                        value={values.idbranchoffices || []}
                                                        options={branchOffices || []}
                                                        getOptionLabel={(option) => option.name || ""}
                                                        fullWidth
                                                        renderInput={(params) => <TextField {...params}  />}
                                                        onChange={(e, newValue) => {
                                                            setFieldValue("idbranchoffices", newValue);
                                                        }}
                                                        size="small"
                                                        readOnly={action == 'detail'}
                                                    />
                                                </Grid>
                                            )
                                        }
                                        <Grid item xs={12}>
                                            {/* <a
                                                onClick={()=>{}}
                                                style={{
                                                    color: 'blue',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {`Asignar usuario existente`}
                                            </a> */}

                                            <a
                                                onClick={()=>{setNewuser(!newuser)}}
                                                style={{
                                                    color: 'blue',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                {`Crear usuario al vendedor`}
                                            </a>
                                        </Grid>
                                        {
                                            newuser && (
                                                <Grid item xs={12} md={6}>
                                                    <FormLabel>Nombre de usuario:</FormLabel>
                                                    <TextField
                                                        id="username"
                                                        type="text" 
                                                        name="username"
                                                        fullWidth
                                                        size="small"
                                                        value={values.username}
                                                        onChange={handleChange}
                                                        error={errors.username && touched.username ? true : false}
                                                        helperText={errors.username && touched.username ? errors.username : ''}
                                                        inputProps={{ readOnly: action == 'detail' }}
                                                    />
                                                </Grid>
                                            )
                                        }
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}